import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import BatteryIndicator from "nexia_mobile/components/BatteryIndicator";
import DateTime from "nx-components/DateTime";
import DetailsHeaderWrapper from "nexia_mobile/components/Details/DetailsHeaders/DetailsHeaderWrapper";
import DetailsImage from "nexia_mobile/components/Details/DetailsImage";
import IconGroup from "nexia_mobile/components/IconGroup";
import parseIconsFromServer from "nexia_mobile/parseIconsFromServer";
import prefixStyles from "nx-components/utils/prefixStyles";
import {
  Battery,
  Connection,
} from "nexia_mobile/models/mixins/device_features";
import Theme from "nx-components/Theme";
import DrawUpdates from "nexia_mobile/components/DrawUpdates";

export default class DefaultDeviceHeader extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
  };

  render() {
    const { model } = this.props;

    const icons = parseIconsFromServer(model.get("icon"), {
      showThermostatTemperatureModifier: true,
    });
    const statusTextPrimary = _.str.capitalize(model.get("status"));
    const statusTextSecondary = model.get("status_secondary");
    const statusTextTertiary = model.get("status_tertiary");

    const hasBattery = Boolean(
      model.hasFeature(Battery) && model.get("battery_label")
    );
    const batteryIcon = model.get("battery_icon");
    const batteryLabel = model.get("battery_label");
    const batteryUpdated = model.get("battery_updated_at");

    const deviceImageSrc = model.get("imageSrc");

    const strength = model.get("connection_strength");
    const hasConnection =
      model.hasFeature(Connection) && strength !== "unknown";
    let signalStrength;
    if (hasConnection) {
      if (_.isNumber(strength)) {
        if (strength < 50) {
          signalStrength = "Low";
        } else {
          signalStrength = `${strength}%`;
        }
      }
    }

    const styles = {
      calloutContainer: prefixStyles({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }),
      statusIcon: {
        fontSize: "4em",
        margin: "0", // remove default margin
        verticalAlign: "middle",
      },
      statusText: {
        display: "inline-block",
        fontSize: ".8em",
        marginLeft: ".25em",
        textAlign: "left",
        verticalAlign: "middle",
      },
      primary: {
        fontSize: "1.1em",
        fontWeight: Theme.Font.WEIGHT_BOLD,
        whiteSpace: "normal",
      },
      secondary: {
        whiteSpace: "normal",
        fontSize: ".8em",
      },
      tertiary: {
        fontSize: ".8em",
        marginTop: ".25em",
        whiteSpace: "normal",
      },
      furtherDetails: {
        marginTop: ".8em auto 0",
        maxWidth: "12em",
      },
      batteryDetails: {
        display: "inline-block",
        fontSize: ".9em",
        marginTop: ".4em",
        textAlign: "left",
      },
      batteryIcon: {
        marginLeft: "-.2em",
      },
      statusTimestamp: {
        fontSize: ".8em",
      },
      statusLabel: {
        fontWeight: Theme.Font.WEIGHT_BOLD,
      },
    };

    return (
      <React.Fragment>
        <DrawUpdates
          listenTo={model}
          events={["change"]}
          getNodeToStyle={() => this._wrapper}
        />
        <DetailsHeaderWrapper
          style={styles.calloutContainer}
          innerRef={(el) => (this._wrapper = el)}
        >
          {deviceImageSrc ? (
            <DetailsImage
              imageSrc={deviceImageSrc}
              imageAlt={model.get("name")}
            />
          ) : (
            <IconGroup values={icons} style={styles.statusIcon} />
          )}
          <span data-component-section="status-text" style={styles.statusText}>
            <div data-component-status="primary" style={styles.primary}>
              {statusTextPrimary}
            </div>
            <div data-component-status="secondary" style={styles.secondary}>
              {statusTextSecondary}
            </div>
            {statusTextTertiary ? (
              <div data-component-status="tertiary" style={styles.tertiary}>
                {statusTextTertiary}
              </div>
            ) : null}
            <div style={styles.furtherDetails}>
              {hasBattery && (
                <div
                  data-component-section="battery"
                  style={styles.batteryDetails}
                >
                  <BatteryIndicator
                    icon={batteryIcon}
                    label={`Battery: ${batteryLabel}`}
                    inline
                    style={styles.batteryIcon}
                  />
                  <br />
                  {batteryUpdated && (
                    <span style={styles.statusTimestamp}>
                      <span style={styles.statusLabel}>{"Last Updated: "}</span>
                      <DateTime relative value={batteryUpdated} />
                    </span>
                  )}
                </div>
              )}
              {hasConnection && (
                <div>
                  {"Signal strength: "}
                  {signalStrength}
                </div>
              )}
            </div>
          </span>
        </DetailsHeaderWrapper>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Details/DetailsHeaders/DefaultDeviceHeader.jsx